module.exports = __webpack_public_path__ + "img/level-1.7f6d5679.png";